import { useState } from "react";
import { Link } from "react-router-dom";
import StorefrontLayout from "../shared/StorefrontLayout";
import { t } from "../../i18n";

const BUYER_SOLUTION_CARDS = [
  {
    title: "solutionsBuyerCard1Title",
    subtitle: "solutionsBuyerCard1Subtitle",
    imageUrl: "/assets/solutions/buyer-wholesaler.jpg",
    needs: [
      "solutionsBuyerCard1Need1",
      "solutionsBuyerCard1Need2",
      "solutionsBuyerCard1Need3"
    ],
    tags: ["solutionsBuyerCard1Tag1", "solutionsBuyerCard1Tag2", "solutionsBuyerCard1Tag3"],
    cta: "/products"
  },
  {
    title: "solutionsBuyerCard2Title",
    subtitle: "solutionsBuyerCard2Subtitle",
    imageUrl: "/assets/solutions/buyer-retailer.jpg",
    needs: [
      "solutionsBuyerCard2Need1",
      "solutionsBuyerCard2Need2",
      "solutionsBuyerCard2Need3"
    ],
    tags: ["solutionsBuyerCard2Tag1", "solutionsBuyerCard2Tag2", "solutionsBuyerCard2Tag3"],
    cta: "/products"
  },
  {
    title: "solutionsBuyerCard3Title",
    subtitle: "solutionsBuyerCard3Subtitle",
    imageUrl: "/assets/solutions/buyer-fitness-brand.jpg",
    needs: [
      "solutionsBuyerCard3Need1",
      "solutionsBuyerCard3Need2",
      "solutionsBuyerCard3Need3"
    ],
    tags: ["solutionsBuyerCard3Tag1", "solutionsBuyerCard3Tag2", "solutionsBuyerCard3Tag3"],
    cta: "/custom-service"
  },
  {
    title: "solutionsBuyerCard4Title",
    subtitle: "solutionsBuyerCard4Subtitle",
    imageUrl: "/assets/solutions/buyer-yoga-studio.jpg",
    needs: [
      "solutionsBuyerCard4Need1",
      "solutionsBuyerCard4Need2",
      "solutionsBuyerCard4Need3"
    ],
    tags: ["solutionsBuyerCard4Tag1", "solutionsBuyerCard4Tag2", "solutionsBuyerCard4Tag3"],
    cta: "/products?group=Yoga%20Mats"
  },
  {
    title: "solutionsBuyerCard5Title",
    subtitle: "solutionsBuyerCard5Subtitle",
    imageUrl: "/assets/solutions/buyer-amazon-seller.jpg",
    needs: [
      "solutionsBuyerCard5Need1",
      "solutionsBuyerCard5Need2",
      "solutionsBuyerCard5Need3"
    ],
    tags: ["solutionsBuyerCard5Tag1", "solutionsBuyerCard5Tag2", "solutionsBuyerCard5Tag3"],
    cta: "/products"
  },
  {
    title: "solutionsBuyerCard6Title",
    subtitle: "solutionsBuyerCard6Subtitle",
    imageUrl: "/assets/solutions/buyer-ecommerce.jpg",
    needs: [
      "solutionsBuyerCard6Need1",
      "solutionsBuyerCard6Need2",
      "solutionsBuyerCard6Need3"
    ],
    tags: ["solutionsBuyerCard6Tag1", "solutionsBuyerCard6Tag2", "solutionsBuyerCard6Tag3"],
    cta: "/products"
  }
];

const USAGE_SCENARIOS = [
  {
    title: "solutionsScenario1Title",
    body: "solutionsScenario1Body",
    imageUrl: "/assets/solutions/scenario-studio-starter.jpg"
  },
  {
    title: "solutionsScenario2Title",
    body: "solutionsScenario2Body",
    imageUrl: "/assets/solutions/scenario-recovery-zone.jpg"
  },
  {
    title: "solutionsScenario3Title",
    body: "solutionsScenario3Body",
    imageUrl: "/assets/solutions/scenario-retail-display.jpg"
  },
  {
    title: "solutionsScenario4Title",
    body: "solutionsScenario4Body",
    imageUrl: "/assets/solutions/scenario-online-bundle.jpg"
  }
];

const PROGRAM_MIXES = [
  {
    title: "solutionsProgram1Title",
    imageUrl: "/assets/solutions/program-mix-studio.jpg",
    body: "solutionsProgram1Body",
    items: ["solutionsProgram1Item1", "solutionsProgram1Item2", "solutionsProgram1Item3"],
    suitedFor: "solutionsProgram1SuitedFor"
  },
  {
    title: "solutionsProgram2Title",
    imageUrl: "/assets/solutions/program-mix-retail.jpg",
    body: "solutionsProgram2Body",
    items: ["solutionsProgram2Item1", "solutionsProgram2Item2", "solutionsProgram2Item3"],
    suitedFor: "solutionsProgram2SuitedFor"
  },
  {
    title: "solutionsProgram3Title",
    imageUrl: "/assets/solutions/program-mix-online.jpg",
    body: "solutionsProgram3Body",
    items: ["solutionsProgram3Item1", "solutionsProgram3Item2", "solutionsProgram3Item3"],
    suitedFor: "solutionsProgram3SuitedFor"
  }
];

export default function SolutionsPage({ apiBaseUrl }) {
  const [currency, setCurrency] = useState("USD");

  return (
    <StorefrontLayout
      apiBaseUrl={apiBaseUrl}
      currency={currency}
      onChangeCurrency={setCurrency}
      showPricing={false}
    >
      <section className="solutions-hero">
        <div className="solutions-hero-copy">
          <p className="hero-kicker">{t("solutionsHeroKicker")}</p>
          <h2>{t("solutionsHeroTitle")}</h2>
          <p>
            {t("solutionsHeroBody")}
          </p>
          <div className="solutions-hero-actions">
            <Link className="button" to="/contact?topic=solutions">{t("solutionsTalkToSales")}</Link>
            <Link className="button ghost-button" to="/products">{t("solutionsBrowseProducts")}</Link>
          </div>
        </div>

        <div className="solutions-hero-visual">
          <img
            src="/assets/solutions/solutions-hero.jpg"
            alt={t("solutionsHeroImageAlt")}
            loading="lazy"
          />
          <div className="solutions-hero-badge">
            <span>{t("solutionsHeroBadgeTitle")}</span>
            <strong>{t("solutionsHeroBadgeBody")}</strong>
          </div>
        </div>
      </section>

      <section className="section-title">
        <h2>{t("solutionsBuyerTypeTitle")}</h2>
      </section>
      <section className="solutions-buyer-grid">
        {BUYER_SOLUTION_CARDS.map((item) => (
          <article key={item.title} className="solutions-buyer-card">
            <img src={item.imageUrl} alt={t(item.title)} loading="lazy" />
            <div className="solutions-buyer-card-copy">
              <h3>{t(item.title)}</h3>
              <p>{t(item.subtitle)}</p>
              <ul className="solutions-buyer-needs">
                {item.needs.map((need) => (
                  <li key={`${item.title}-${need}`}>{t(need)}</li>
                ))}
              </ul>
              <div className="solutions-buyer-tags">
                {item.tags.map((tag) => (
                  <span key={`${item.title}-${tag}`}>{t(tag)}</span>
                ))}
              </div>
              <Link className="button ghost-button solutions-buyer-link" to={item.cta}>{t("solutionsViewMatchingProducts")}</Link>
            </div>
          </article>
        ))}
      </section>

      <section className="section-title">
        <h2>{t("solutionsScenarioPlansTitle")}</h2>
      </section>
      <section className="solutions-scenario-grid">
        {USAGE_SCENARIOS.map((item) => (
          <article key={item.title} className="solutions-scenario-card">
            <img src={item.imageUrl} alt={t(item.title)} loading="lazy" />
            <div className="solutions-scenario-overlay">
              <h3>{t(item.title)}</h3>
              <p>{t(item.body)}</p>
            </div>
          </article>
        ))}
      </section>

      <section className="section-title">
        <h2>{t("solutionsProgramMixesTitle")}</h2>
      </section>
      <section className="solutions-program-grid">
        {PROGRAM_MIXES.map((item) => (
          <article key={item.title} className="solutions-program-card">
            <img src={item.imageUrl} alt={t(item.title)} loading="lazy" />
            <div className="solutions-program-copy">
              <p className="hero-kicker">{t(item.suitedFor)}</p>
              <h3>{t(item.title)}</h3>
              <p>{t(item.body)}</p>
              <div className="solutions-program-tags">
                {item.items.map((entry) => (
                  <span key={`${item.title}-${entry}`}>{t(entry)}</span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </section>

      <section className="solutions-cta-panel">
        <div>
          <p className="hero-kicker">{t("solutionsNextStepKicker")}</p>
          <h2>{t("solutionsNextStepTitle")}</h2>
          <p>{t("solutionsNextStepBody")}</p>
        </div>
        <div className="solutions-hero-actions">
          <Link className="button" to="/contact?topic=solutions">{t("solutionsRequestPlan")}</Link>
          <Link className="button ghost-button" to="/custom-service">{t("solutionsExploreOem")}</Link>
        </div>
      </section>
    </StorefrontLayout>
  );
}